import {
  TRANSACTION_FETCH,
  TRANSACTION_FETCH_SUCCESS,
  TRANSACTION_FETCH_FAIL,
  TRANSACTION_SUMMARY_FETCH,
  TRANSACTION_SUMMARY_FETCH_SUCCESS,
  TRANSACTION_SUMMARY_FETCH_FAIL,
  TRANSACTION_MONTHLY_FETCH,
  TRANSACTION_MONTHLY_FETCH_SUCCESS,
  TRANSACTION_MONTHLY_FETCH_FAIL,
  TRANSACTION_MACHINETYPE_FETCH,
  TRANSACTION_MACHINETYPE_FETCH_SUCCESS,
  TRANSACTION_MACHINETYPE_FETCH_FAIL,
  TRANSACTION_CONFIRMATION_FETCH,
  TRANSACTION_CONFIRMATION_FETCH_SUCCESS,
  TRANSACTION_CONFIRMATION_FETCH_FAIL,
  TRANSACTION_BY_SERVICE_FETCH,
  TRANSACTION_BY_SERVICE_FETCH_SUCCESS,
  TRANSACTION_BY_SERVICE_FETCH_FAIL
} from '../actions';

const INIT_STATE = {
    transaction: [],
    loading: false,
    error: '',
    updatedate: false,
    totalAmount: 0,
    transactionSummary: {totalAmount: 0, totalCount: 0, totalAvg: 0},
    monthlyPeriod: [],
    monthlyAmount: [],
    transactionCharts: {period: [], amount: []},
    tranMachineType: {label: ["0"], amount:[0]},
    tranConfirmation: 0,
    tranByService: {label: ["n/a"], amount:[0]}
};

export default (state = INIT_STATE, action) => {
  // console.log('type',action.type)
  // console.log('payload',action.payload)
    switch (action.type) {
        case TRANSACTION_FETCH:
            return { ...state, loading: true, error: '', updatedate: true };
        case TRANSACTION_FETCH_SUCCESS:
            return {
              ...state,
              loading: false,
              transaction: action.payload.transaction,
              totalAmount: action.payload.total,
              error: '', updatedate: false
            };
        case TRANSACTION_FETCH_FAIL:
            return { ...state, loading: false, transaction: [], error: action.payload.message, totalAmount: 0 };

        case TRANSACTION_SUMMARY_FETCH:
           return { ...state, loading: true, error: ''};
        case TRANSACTION_SUMMARY_FETCH_SUCCESS:
           return { ...state, loading: false, transactionSummary: action.payload.transactionSummary, error: '' };
        case TRANSACTION_SUMMARY_FETCH_FAIL:
           return { ...state, loading: false,transactionSummary: {totalAmount: 0, totalCount: 0, totalAvg: 0}, error: action.payload.message};

        case TRANSACTION_MONTHLY_FETCH:
           return { ...state, loading: true, error: '' };
        case TRANSACTION_MONTHLY_FETCH_SUCCESS:
           return { ...state, loading: false, error: '', monthlyPeriod: action.payload.period, monthlyAmount: action.payload.amount};
        case TRANSACTION_MONTHLY_FETCH_FAIL:
            return { ...state, loading: false, monthlyPeriod: action.payload.message.period, monthlyAmount: action.payload.message.amount};

        case TRANSACTION_MACHINETYPE_FETCH:
            return { ...state, loading: true, error: '' };
        case TRANSACTION_MACHINETYPE_FETCH_SUCCESS:
            return { ...state, loading: false, error: '', tranMachineType: action.payload};
        case TRANSACTION_MACHINETYPE_FETCH_FAIL:
            return { ...state, loading: false, error: action.payload.message};

        case TRANSACTION_CONFIRMATION_FETCH:
            return { ...state, loading: true, error: '' };
        case TRANSACTION_CONFIRMATION_FETCH_SUCCESS:
            return { ...state, loading: false, error: '', tranConfirmation: action.payload};
        case TRANSACTION_CONFIRMATION_FETCH_FAIL:
            return { ...state, loading: false, error: action.payload.messageม };

        case TRANSACTION_BY_SERVICE_FETCH:
            return { ...state, loading: true, error: '' };
        case TRANSACTION_BY_SERVICE_FETCH_SUCCESS:
            return { ...state, loading: false, error: '', tranByService: action.payload};
        case TRANSACTION_BY_SERVICE_FETCH_FAIL:
            return { ...state, loading: false, error: action.payload.message};

        default: return { ...state };
    }
}
